export const SET_STATE = 'advertsFilters/SET_STATE';
export const SET_DEPARTURE_OPTIONS = 'advertsFilters/SET_DEPARTURE_OPTIONS';
export const SET_DEPARTURE_VALUE = 'advertsFilters/SET_DEPARTURE_VALUE';
export const SET_MONTH_OPTIONS = 'advertsFilters/SET_MONTH_OPTIONS';
export const SET_MONTH_VALUE = 'advertsFilters/SET_MONTH_VALUE';
export const SET_TRAVEL_LENGTH_OPTIONS = 'advertsFilters/SET_TRAVEL_LENGTH_OPTIONS';
export const SET_TRAVEL_LENGTH_VALUE = 'advertsFilters/SET_TRAVEL_LENGTH_VALUE';
export const RESET_STATE = 'advertsFilters/RESET_STATE';
